import { memo } from 'react';
import { NODE_WIDTH, NODE_HEIGHT } from '../const';
import { InnerNodeComponent, NodeComponent } from './components/SweepNodeComponent';
import { RfDropZoneNode } from '../canvas-types/nodeTypesData';
import { NodeProps } from '@xyflow/react';
import { colors, Typography } from '@sweep-io/sweep-design';
import { SweepNodeHandles } from './SweepNodeHandles';
import classNames from 'classnames';

const DropZoneNode = ({ data }: NodeProps<RfDropZoneNode>) => {
  if (data.type === 'regular') {
    return (
      <SweepNodeHandles>
        <NodeComponent
          sx={{
            width: `${NODE_WIDTH}px`,
            height: `${NODE_HEIGHT}px`,
            border: '2px solid transparent',
            cursor: 'default',
            background: 'black',
            opacity: 0.04,
          }}
        />
      </SweepNodeHandles>
    );
  } else if (data.type === 'swap') {
    const { objectType, name } = data;
    return (
      <SweepNodeHandles>
        <NodeComponent
          className={classNames({
            [`node-${objectType}`]: true,
          })}
          sx={{
            border: `2px solid ${colors.blue[500]}`,
            borderRadius: '4px',
            cursor: 'default',
            background: `${colors.blue[500]}0D`,
            opacity: 0.4,
          }}
        >
          <InnerNodeComponent pr={'12px'}>
            <Typography variant="body-medium">{name}</Typography>
          </InnerNodeComponent>
        </NodeComponent>
      </SweepNodeHandles>
    );
  }

  return <></>;
};

const _memoDropZoneNode = memo(DropZoneNode);

export { _memoDropZoneNode as DropZoneNode };
